/* eslint-disable jsx-a11y/alt-text */
import { useState, useEffect, useCallback } from 'react'

import Card from '@mui/material/Card'
import Image from 'next/image'
import Img from '../../../public/images/apps/7.png'
import Img2 from '../../../public/images/apps/8.jpg'
import Img3 from '../../../public/images/apps/11.png'
import Img4 from '../../../public/images/apps/17.svg'
import Img5 from '../../../public/images/apps/18.png'
import Img6 from '../../../public/images/apps/19.png'
import Img7 from '../../../public/images/apps/3.png'
import Img8 from '../../../public/images/apps/5.png'
import Img9 from '../../../public/images/apps/6.png'
import Img11 from '../../../public/images/apps/12.svg'
import Img12 from '../../../public/images/apps/13.svg'
import Img13 from '../../../public/images/apps/14.svg'
import Img14 from '../../../public/images/apps/15.png'
import Img15 from '../../../public/images/apps/16.png'
import Img16 from '../../../public/images/apps/19.webp'
import Img17 from '../../../public/images/apps/20.webp'
import Img18 from '../../../public/images/apps/21.webp'
import Img19 from '../../../public/images/apps/22.webp'
import { styled } from '@mui/material/styles'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { Icon } from '@iconify/react'

function Index() {
  const APPLICATIONS = [
    {
      id: 1,
      title: 'Youtube',
      img: Img,
      time: '29 Oct, 05:47 pm',
      size: '14.94 MB'
    },
    {
      id: 2,
      title: 'TikTok',
      img: Img2,
      time: '29 Oct, 05:42 pm',
      size: '2.6 GB'
    },
    {
      id: 3,
      title: 'Twitter',
      img: Img3,
      time: '29 Oct, 04:25 pm',
      size: '114.65 MB'
    },
    {
      id: 4,
      title: 'Telegram',
      img: Img4,
      time: '29 Oct, 04:22 pm',
      size: '395.63 MB'
    },
    {
      id: 5,
      title: 'Pinterest',
      img: Img5,
      time: '29 Oct, 04:14 pm',
      size: '36.95 MB'
    },
    {
      id: 6,
      title: 'Gmail',
      img: Img6,
      time: '29 Oct, 03:59 pm',
      size: '71.84 MB'
    },
    {
      id: 7,
      img: Img7,
      title: 'Instagram',
      time: '29 Oct, 05:39 pm',
      size: '71.84 MB'
    },
    {
      id: 8,
      img: Img8,
      title: 'Facebook',
      time: '29 Oct, 03:59 pm',
      size: '71.84 MB'
    },
    {
      id: 9,
      img: Img9,
      title: 'Tinder',
      time: '22 Oct, 03:02 pm',
      size: '1.9 GB'
    },
    {
      id: 10,
      img: Img11,
      title: 'Viber',
      time: '29 Oct, 12:89 pm',
      size: '362.25 MB'
    },
    {
      id: 11,
      img: Img12,
      title: 'Kik',
      time: '28 Oct, 03:49 pm',
      size: '364.84 MB'
    },
    {
      id: 12,
      img: Img13,
      title: 'Skype',
      time: '29 Oct, 02:59 pm',
      size: '279.84 MB'
    },
    {
      id: 13,
      img: Img14,
      title: 'Messenger',
      time: '29 Oct, 03:59 pm',
      size: '171.84 MB'
    },
    {
      id: 14,
      img: Img15,
      title: 'Chrome Browser',
      time: '29 Oct, 03:50 pm',
      size: '1.1 GB'
    },
    {
      id: 15,
      img: Img16,
      title: 'Safari',
      time: '28 Oct, 06:20 pm',
      size: '196.3 MB'
    },
    {
      id: 17,
      img: Img18,
      title: 'Music',
      time: '27 Oct, 12:10 pm',
      size: '105.63 MB'
    },
    {
      id: 18,
      img: Img19,
      title: 'Shadowrocket',
      time: '27 Oct, 11:36 pm',
      size: '241 MB'
    }
  ]

  const [data, setData] = useState(APPLICATIONS)

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 4,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#097ae4' : '#308fe8'
    }
  }))

  const inputChangeHandler = e => {
    const valueData = e.target.value.trim().toLowerCase()
    const Data = APPLICATIONS.filter(index => index.title.toLowerCase().indexOf(valueData) !== -1)
    setData(Data)
  }

  return (
    <Card>
      <div className=' bg-[#f5f6fa]  pb-6 w-full '>
        <div className='flex  bg-white  h-[60px] sm:h-[70px] pl-2'>
          <div className='flex w-[98%] sm:w-full  mx-auto justify-between items-center'>
            <div className=''>
              <div className='flex   items-center'>
                <div className=' absolute'>
                  <i className=''>
                    <Icon icon='ep:search' className='w-[18px] h-[18px] text-black text-opacity-60 ml-1' />
                  </i>
                </div>
                <div className='flex items-center '>
                  <input
                    onChange={inputChangeHandler}
                    type='text'
                    placeholder='Search Applications'
                    className='flex sm:w-4/5 h-[35px] sm:h-[30px] rounded-3xl outline-none pl-8 text-[15px] placeholder-[#667089]'
                  ></input>
                </div>
              </div>
            </div>

            <div class=' sm:w-10/12 w-1/4 md:mr-4 sm:mr-2'>
              <div className='flex text-[0.75rem] text-[#667089] text-bold justify-between'>
                <h2 class='text-[#667089] font-medium sm:text-[0.5rem]'>DEVICE STORAGE</h2>
                <p className='text-[13px] sm:text-[12px]'>15.60 GB used of 127.85 GB</p>
              </div>
              <div className='mt-2'>
                <BorderLinearProgress variant='determinate' value={12} />
              </div>
            </div>
          </div>
        </div>

        <div className='mt-4 bg-white md:w-[95%] rounded-lg mx-auto '>
          {data.map(app => {
            return (
              <div
                key={app.id}
                className=' flex justify-between text-[0.875rem] text-[#4d5976] h-[70px] items-center border-b-[1px] border-[#e6e8ec]  sm:text-[0.7rem]  '
              >
                <div className='flex ml-4'>
                  <div className='flex items-center justify-center'>
                    <Image
                      src={app.img}
                      alt='img'
                      className='flex w-[34px] h-[34px] sm:w-[20px] sm:h-[20px] rounded-xl '
                    />
                  </div>
                  <div className='pl-6 sm:pl-3'>
                    <h2 className='font-bold text-[#4d5976] text-opacity-95'>{app.title}</h2>
                    <p class='text-[13px] mt-1'>Last Used:{app.time}</p>
                  </div>
                </div>
                <div className='flex md:mr-4'>
                  <div class='flex'>
                    <h2 className=''>{app.size}</h2>
                    <Icon icon='material-symbols:chevron-right-rounded' width={20} height={20} class='text-[#fff]' />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </Card>
  )
}

export default Index
